import { Grid } from "@mui/material";
import { styled } from "@mui/material/styles";

export const DropdownMenu = styled(Grid)(({ theme }) => ({
  paddingTop: theme.spacing(2),
  paddingRight: theme.spacing(2),
  paddingLeft: theme.spacing(2),
  overflow: "auto",
}));
